// @ts-nocheck
export const courseTypeObj = {
  TEMPORAL_ACCESS: 'temporal-access',
  FREEMIUM: 'freemium',
  MEMBERSHIP: 'membership',
  FREE: 'free',
  PAID: 'paid',
  B2B: 'b2b',
  ROCKSTAR: 'rockstar',
};

export const dateOptions = {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
  timeZone: 'UTC',
};
